/**
 * Reducer to manage user account related state
 */

import serverProps from '../lib/server-props'

const initialState = {
  griffinMetadata: serverProps.griffinMetadata,
  language: serverProps.language,
  userHasXoomAccount: serverProps.userHasXoomAccount,
  showRecipientFirst: serverProps.recipientFirst,
  isAccountLinkedToXoom: serverProps.isAccountLinkedToXoom, // is user's PP account linked to Xoom (seamless login, etc)?
  xoomBaseUrl: serverProps.xoomBaseUrl,
  payerPrimaryCurrencyCode: '',
}

/**
 * Reducer. Pure function that mutates this part of the store
 * and returns a new obj.
 */
export default function user(state = initialState) {
  return state
}
